module.exports = __webpack_public_path__ + "static/media/COS_MAYOLY_IPSEN.2738b9d6.jpg";